module.exports = __webpack_public_path__ + "static/img/gwzscl.acde5a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/gwzscl.png
// module id = 85rw
// module chunks = 0